import API from './config'

function getConfig() {
    return {
        headers: {
            'x-access-token': localStorage.getItem('token'),
        }
    }
}

async function doRequest(request) {
    try {
        const response = await request();
        return {
            success: true,
            body: response.data
        };
    } catch (error) {
        return {
            success: false,
            body: error.response ? error.response.data : error
        };
    }
}

export const ClientContractValuesAPI = {

    /**
     * Histórico de valores de contrato ativos do cliente, do início de vigência mais recente ao mais antigo
     * @param {number} clientId
     */
    async listByClient(clientId) {
        return doRequest(() => API.get(`/client-contract-values/client/${clientId}`, getConfig()));
    },

    /**
     * @param {{client_id: number, contract_value: string, start_date: string}} data - start_date em YYYY-MM-DD
     */
    async create(data) {
        return doRequest(() => API.post('/client-contract-values', data, getConfig()));
    },

    /**
     * @param {number} id
     * @param {{contract_value: string, start_date: string}} data - start_date em YYYY-MM-DD
     */
    async update(id, data) {
        return doRequest(() => API.put(`/client-contract-values/${id}`, data, getConfig()));
    },

    /**
     * Exclui um registro do histórico (soft delete)
     */
    async remove(id) {
        return doRequest(() => API.delete(`/client-contract-values/${id}`, getConfig()));
    },
};
